export const sumArraysByKeys = (obj, keys) => {

    if (keys.length === 0) return [];

    const length = obj[keys[0]].length;

    const result = Array(length).fill(0);

    keys.forEach(key => {
        obj[key].forEach((value, index) => {
            result[index] += value;
        });
    });

    return result.map(num => parseFloat(num.toFixed(2)));
}